import { Button } from 'react-bootstrap'
import Modal from 'components/Modal/Modal'
import { toggleDisplayMode } from 'redux/features/etudierMarche/slice'
import { Status, showParcelleResults, idleDvf } from 'redux/features/dvf/slice'
import { makeSelectStatusDvf } from 'redux/features/dvf/selectors'
import { useAppSelector, useAppDispatch } from 'redux/hooks'
import s from './BeaucoupDeResultats.module.scss'

const BeaucoupDeResultats = (): JSX.Element => {
  const statusDvf = useAppSelector(makeSelectStatusDvf)
  const dispatch = useAppDispatch()

  const handleClose = () => {
    dispatch(showParcelleResults())
  }

  const handleRevoirCriteres = () => {
    dispatch(idleDvf())
    dispatch(toggleDisplayMode('normal'))
  }

  const handlePasRevoirCriteres = () => {
    dispatch(showParcelleResults())
  }

  const show = statusDvf === Status.ShowModalBeaucoupDeResultats

  return (
    <Modal
      show={show}
      onCloseButtonClick={handleClose}
      additionalModalClassNames={s.beaucoupDeResultats}
      title="Votre recherche comporte trop de résultats"
      body={
        <>
          <p>
            Votre recherche comprend trop de résultats.
            <br />
            <br />
            Nous vous conseillons d&apos;affiner les critères de recherche.
            (dates de transactions, surfaces, ...)
          </p>
          <div className={s.controls}>
            <Button
              onClick={handlePasRevoirCriteres}
              className={s.btn}
              variant="outline-primary"
            >
              Je ne revois pas les critères
            </Button>
            <Button onClick={handleRevoirCriteres} className={s.btn}>
              Je revois les critères
            </Button>
          </div>
        </>
      }
    />
  )
}

export default BeaucoupDeResultats
